import { getLink } from '../../../../utils/utils';

import author from './author';

const content = {
  rus: (
    `
    <div style="text-align: justify;">
      
      <p class="mb-3">
      </p>
      <p class="mb-3">
        Что мне теперь делать?
      </p>
      
      <p class="mb-3">
        Что будет со мной, одним на чужой планете, беспомощным, бессильным?
      </p>
      
      <p class="mb-3">
        Мне страшно, я извиваюсь от ужаса и отчаяния, у меня больше нет сил. 
        Я ничего не могу. 

      </p>
      
      <p class="mb-3">
        Они улетели три дня назад.
      </p>
      
      <p class="mb-3">
        Самое страшное, однако, не моё одиночество, а моя беспомощность. 
        В голове – каша из непонятных слов, звуков… Я забыл значения всех слов, и они для меня остались – просто звукосочетания, 
        ничего не объясняющие, пустые.
      </p>
      
      <p class="mb-3">
        Я потерял самого себя.
      </p>


      <p class="text-center bold mb-3">* * *</p>


      <p class="mb-3">
        Это началось, когда мы выходили из Корабля. 
        Как всегда, мы строго следовали Ритуалу: произнеся необходимые заклинания, мы спрокили крумбы, увренили фальбуки и плотно замургили пертены. 
        Только после этого мы имели право выйти из Корабля. 

      </p>
      
      <p class="mb-3">
        Я был первым; когда мои ноги коснулись поверхности, она будто качнулась, и у меня закружилась голова. 
        Да какого дьявола! Я не нежная барышня, чтобы падать в обморок!
      </p>
      
      <p class="mb-3">
        Когда я упал, Капитан прекратил Выход.
      </p>
      
      <p class="mb-3">
        Я попытался доползти до Корабля, но увидел плотно закрытый люк. 
        Много времени прошло, прежде чем я понял, что меня не пустят назад. 

      </p>
      
      <p class="mb-3">
        Затем я понял: Ритуал.
      </p>
      
      <p class="mb-3">
        Я нарушил Ритуал, и этим навсегда вычеркнул себя из числа людей.
      </p>
      
      <p class="mb-3">
        Без Ритуала невозможна жизнь; он наш дух и наша плоть, он воздух, которым мы дышим. 
        Служители Ритуала встречают нас при рождении; они учат в школах, а самые способные из нас затем изучают полный обряд Ритуала в университетах, 
        чтобы самим стать Служителями Высшего. 
        Я – простой кальпумист, но и я, как и все другие, ничего не могу без Ритуала: без него невозможна никакая работа или деятельность вообще. 
        Без него мы ничто. 

      </p>
      
      <p class="mb-3">
        И вот – я нарушил Ритуал. 
        И он ушёл от меня. 
        Я забыл его. 
        Я стал ничем.
      </p>
    

      <p class="text-center bold mb-3">* * *</p>


      <p class="mb-3">
        Прошло уже два месяца, как я здесь.
      </p>
      
      <p class="mb-3">
        Я ещё не умер.
      </p>
      
      <p class="mb-5">
        Я питаюсь вещами, окружающими меня. 
        Я не знаю, как они называются. 
        Одни сладкие, другие – почти безвкусные, но питательные. 
        Я называю их «фрукты» и «овощи», хотя это совершенно другие вещи. 
        Я вижу, что мне придётся давать названия всем вещам, которые окружают меня в этом новом мире. 
        Давать названия, узнавать… только это спасает меня в этой странной, одинокой и часто невыносимой жизни. 
      </p>


      <p class="text-center bold mb-3">* * *</p>
      

      <p class="mb-3 italic">
        Вот первые тексты Святого Послания нашего, 
        Евангелия от благословенного Спасителя и Учителя, который дал имя всякой твари живущей и прозябающей. 
        Он дал нам язык наш, научил выращивать растения и скот, Он подарил нам Мир наш со всем, что в нём есть!
      </p>
      
      <p class="mb-3 italic">
        Славьте нашего Создателя! Славьте Его вместе и поодиночке, и в каждом сердце пусть горит любовь к нашему Дарителю и царит поклонение Ему! 
      </p>
      
      <p class="mb-3 italic">
        И помните Его слова, никогда не забывайте их, чтобы всё, сказанное Им, навсегда осталось неизменным и вечным! 
      </p>


      <p class="text-center bold mb-3">* * *</p>


      <p class="mb-3">
        Я понял, что произошло со мной; что произошло с нами всеми.
      </p>
      
      <p class="mb-3">
        Когда-то, в древности, когда мы были такими же дикими, как эти племена, окружающие меня, произошло вторжение на Землю, 
        и пришельцы решили «осчастливить» нас новым знанием, «цивилизовать» нас. 
      </p>
      
      <p class="mb-3">
        Они дали нам ценные знания, и мы приняли их радостно, не задумываясь.
      </p>
      
      <p class="mb-3">
        Не задумываясь.
      </p>
      
      <p class="mb-3">
        Мы остались на том же уровне развития, и больше уже не исследовали окружающий реальный мир. 
        Мы не развивались. 
        Как машины, мы были запрограммированы на определённую деятельность. 
        Мы умели управлять машинами, чинить их, даже до какой-то степени усовершенствовать – но мы не знали принципов, 
        на которых была основана их работа, они оставались чуждыми и непонятными нам. 
        Мы управляли транспортом, варили сталь, 
        производили колбасу с помощью «заклинаний» - инструкций и заученных без понимания действий – об этом заботились наши Учителя Ритуала. 

      </p>
      
      <p class="mb-5">
        Мы потеряли всё наше и не получили ничего взамен; мы вообще ничего не получили. 
        Инструкции к машинам стали нашими Священными книгами; пастыри объясняли нам, как управлять аппаратурой; а мы только запоминали, 
        слушались и верили. 
        Как слепые, мы столетиями повторяли слова вместо того, чтобы  понимать,  вместо того, чтобы смотреть и видеть. 
        И вся наша цивилизация, такая могучая, уже достигшая других планет, оказалась бессмысленной и пустой...
      </p>


      <p class="text-center bold mb-3">* * *</p>

      
      <p class="mb-3">
        Но кто были эти «Благодетели», так «осчастливившие» нас? Кто провёл такой ужасный эксперимент над человечеством, 
        лишивший его собственной воли, собственного пути развития?
      </p>
      
      <p class="mb-3">
        Я единственный из людей, кто спасся. 
        Под влиянием атмосферы этой планеты в моей голове распались какие-то нервные связи, исчезло всё, что было связано с закреплёнными навыками, 
        с Ритуалом, и я стал нормальным человеком – зрячим среди зрячих, живым среди живых. 
      </p>
      
      <p class="mb-5">
        По крайней мере, этому племени я смогу объяснить всё, предостеречь их. 
        Они такие наивные, так верят мне. 
        И я расскажу им о нашей несбывшейся культуре, о бессмысленности машинного прогресса, о радости естественной жизни, 
        о необходимости собственного пути – обо всём, что я сам понял; и они поймут меня, они не направятся по нашему ложному пути!
      </p>

      
      <p class="text-center bold mb-3">* * *</p>

      
      <p class="mb-3">
        Не к мёртвым словам, не к мёртвым машинам должен стремиться человек, чтобы жить и развиваться. 
        Только Природа даёт силы и саму жизнь; Природу нужно познавать: окружающую природу и свою собственную природу человека. 
        Я научу их, что каждый народ, каждый человек должен идти своим путём развития. 
        Только свободный выбор, без подсказок или «облагодетельствования», может указать дорогу к счастью.
      </p>
      
      <p class="mb-3">
        Я открою им Истину, и они станут всесильны, они свободно, с открытыми глазами овладеют окружающим миром. 
        Они не повторят наших ошибок, и, сильные и могучие, не зависящие от чужих влияний, они достигнут счастья! 
        Это мой долг совести перед ними.
      </p>

      
      <p class="text-center bold mb-3">* * *</p>


      <p class="mb-3 italic">
        Славься, наш благодетель! Будь благословен Ты и Послание Твоё, единственный наш факел во мраке! 
        Только следуя Тебе, спасёмся мы! Слава нашему Пастырю!
      </p>
      
      <p class="mb-3 italic">
        Мы, поклоняясь Тебе, сделаем всё, чтобы люди следовали за Тобой, никогда не отклоняясь, только по пути, 
        Тобой указанному, единственно верному. 
      </p>
      
      <p class="mb-3 italic">
        Мы передадим Твои слова потомкам нашим, и пока мир наш стоит, будет жить вера в Заветы, данные Тобой! 
        Мы будем бережно сохранять их, вручать и нынешним, и будущим поколениям, и не погибнет это знание в веках! 
        Мы построим церкви и школы, и ни одно слово из сказанных Тобой не будет утеряно!
      </p>
      
      <p class="mb-3 italic">
        Слава повелителю наших жизней!
      </p>
      
      <p class="mb-3 italic">
        Пока мы живы, никто не выйдет из власти твоей; и мы все спасёмся словами Твоими!
      </p>
      
      <p class="mb-3 italic">
        Будь вечно благословен!! 
      </p>

    </div>
    `
  )
}

const itemName = {
  rus: `По кругу`
}


const item = {
  itemlink: getLink(itemName.rus),
  rus: {
    itemName: itemName.rus,
    itemContent: content.rus,
    itemAuthor: author.rus
  }
}

export default item;